<!-- Add/Edit Discount Modal -->
<div class="modal-header">
    <h5 class="modal-title" id="editDiscountTitle">Edit Discount</h5>
    <button type="button" (click)="dismiss()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-8 mb-3">
            <label for="discountValue" class="form-label">Value</label>
            <input type="text" [(ngModel)]="discount.value" class="form-control" id="discountValue" placeholder="value">
        </div>
        <div class="col-md-4 mb-3">
            <label for="discountLimit" class="form-label">Redemption Limit</label>
            <input type="text" [(ngModel)]="discount.redemptionLimit" class="form-control" id="discountLimit" placeholder="limit">
        </div>
    </div>
    <div class="row">
        <div class="col-md-6 mb-3">
            <label for="discountStart" class="form-label">Start Date</label>
            <input type="text"  [(ngModel)]="discount.startDate" class="form-control" id="discountStart" placeholder="start">
        </div>
        <div class="col-md-6 mb-3">
            <label for="discountEnd" class="form-label">End Date</label>
            <input type="text" [(ngModel)]="discount.endDate" class="form-control" id="discountEnd" placeholder="end">
        </div>
    </div>

</div>
<div class="modal-footer">
    <button type="button" (click)="UpdateDiscount()" class="btn btn-sb border-lb text-strong text-uppercase m-100">Save</button>
    <button type="button" (click)="dismiss()" class="btn btn-cancel text-strong text-uppercase m-100" data-bs-dismiss="modal">Cancel</button>
</div>